// GF1 — Gömülü form modu (Dokumanlar/Arayuz/GOMULU-FORM-TEMA-PLANI.md §4).
// Yalnız ?gom=1 iken çalışır; gom yokken hiçbir değişken/sınıf yazılmaz (varsayılan görünüm aynı).
//
// Katmanlar (alan bazında, §4.5): profil > URL parametresi > otomatik okuma (host teması) > varsayılan.
// Mesajlaşma (§4.2): { tip: 'hepy:<ad>', v: 1, ... }. postMessage'ta '*' HİÇ kullanılmaz; host origin
// ancestorOrigins → document.referrer → ilk hepy:init'in origin'i sırasıyla belirlenir.
// Kullanıcı kararları: S1 = KDU beforeunload gömülüde de kalır (hepy:kirli yalnız ek bilgi);
// S2 = izinli alan listesi dolu + host belirlenemiyor → kilit (fail-closed);
// S3 = Google Fonts yok; yalnız profil YaziTipiUrl verirse o CSS yüklenir.

import { reactive, watch } from "vue";
import { kirliVarMi } from "./kirliKayit";

const PROTOKOL_V = 1;
const HEX_RE = /^#?([0-9a-f]{3}|[0-9a-f]{4}|[0-9a-f]{6}|[0-9a-f]{8})$/i;
const FONT_RE = /^[\w\s,'".-]{1,200}$/;
const KOD_RE = /^[a-z0-9-]{1,40}$/;
const HTTPS_RE = /^https:\/\/[^\s"'<>]+$/i;
const HTTP_RE = /^https?:\/\/[^\s"'<>]+$/i;
const INIT_BEKLEME_MS = 3000;
const PROFIL_BEKLEME_MS = 6000;

// Yol → form anahtarı (embed.js ile aynı tablo, plan §3)
const FORM_YOLLARI = {
  "/onkayit/onkayitform": "onkayit",
  "/randevusistemi/randevual": "randevu",
  "/teklif/talepolustur": "talep",
  "/cagrisistemi/cagriolustur": "cagri",
};

const TEAL500 = [20, 184, 166];
const BEYAZ = [255, 255, 255];
const SIYAH = [0, 0, 0];

export const gomuluDurum = reactive({
  aktif: false,
  hazir: false, // profil + izin kontrolü bitti → router-view gösterilir
  kilitli: false,
  profilVar: false,
  logoGoster: true,
  butonMetni: "",
  sonrasiMesaj: "",
  sonrasiUrl: "",
  devamUrl: "", // yönlendirme engellenirse "Devam et" bağlantısı
});

let baslatildi = false;
let urlK = {};
let temaK = {};
let profilK = {};
let profilHam = null;
let hostOrigin = null;
let initAlindi = false;
let kuyruk = [];
let initBekleyenler = [];
let yazilanlar = [];
let sonBoy = 0;
let boyZamanlayici = null;
let fontLinki = null;

// ── Yardımcılar ─────────────────────────────────────────────────────────────
function cerceveIcinde() {
  try { return window.parent !== window; } catch (e) { return true; }
}

function hexCoz(v) {
  if (!v || typeof v !== "string") return null;
  const s = v.trim();
  if (!HEX_RE.test(s)) return null;
  let h = s.replace(/^#/, "");
  if (h.length <= 4) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.slice(0, 2), 16), g = parseInt(h.slice(2, 4), 16), b = parseInt(h.slice(4, 6), 16);
  if (h.length === 8 && parseInt(h.slice(6, 8), 16) === 0) return null; // tam saydam
  return [r, g, b];
}

// Host'tan gelen "rgb(…)"/"rgba(…)"/hex metni → [r,g,b]; saydam → null
function renkCoz(v) {
  if (!v || typeof v !== "string") return null;
  const hex = hexCoz(v);
  if (hex) return hex;
  const m = v.trim().match(/^rgba?\(\s*([\d.]+)[\s,]+([\d.]+)[\s,]+([\d.]+)(?:[\s,/]+([\d.]+%?))?\s*\)$/i);
  if (!m) return null;
  if (m[4] !== undefined) {
    const a = m[4].endsWith("%") ? parseFloat(m[4]) / 100 : parseFloat(m[4]);
    if (!(a > 0.05)) return null;
  }
  const k = (x) => Math.max(0, Math.min(255, Math.round(parseFloat(x))));
  return [k(m[1]), k(m[2]), k(m[3])];
}

function fontCoz(v) {
  if (!v || typeof v !== "string") return null;
  const s = v.trim();
  return FONT_RE.test(s) ? s : null;
}

function koseCoz(v) {
  if (v === null || v === undefined || v === "") return null;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  // GF-T2: aralık dışı / sayı değil → yok sayılır (embed.js ve doküman ile aynı; sıkıştırma yok)
  if (isNaN(n) || n < 0 || n > 32) return null;
  return Math.round(n);
}

function karistir(a, b, t) {
  return [0, 1, 2].map((i) => Math.round(a[i] * (1 - t) + b[i] * t));
}

// WCAG göreli parlaklık (0-1)
function parlaklik(c) {
  const l = c.map((x) => {
    const s = x / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  });
  return 0.2126 * l[0] + 0.7152 * l[1] + 0.0722 * l[2];
}

const uclu = (c) => c.join(" ");
const rgb = (c) => "rgb(" + c.join(",") + ")";

function ilkDolu() {
  for (let i = 0; i < arguments.length; i++) {
    const v = arguments[i];
    if (v !== null && v !== undefined) return v;
  }
  return null;
}

// ── Katmanlar ───────────────────────────────────────────────────────────────
export function gomuluMu() {
  if (baslatildi) return gomuluDurum.aktif;
  try { return new URLSearchParams(window.location.search).get("gom") === "1"; } catch (e) { return false; }
}

export function urlKatmani(q) {
  const k = {
    birincil: hexCoz(q.get("birincil")),
    arkaplan: hexCoz(q.get("arkaplan")),
    yazi: hexCoz(q.get("yazi")),
    kenar: hexCoz(q.get("kenar")),
    kose: koseCoz(q.get("kose")),
    font: fontCoz(q.get("font")),
    logo: q.get("logo") === "0" ? false : q.get("logo") === "1" ? true : null,
    otomatik: q.get("otomatik") === "0" ? false : null,
    saydam: q.has("saydam") ? q.get("saydam") !== "0" : null,
  };
  return k;
}

function profilKatmani(p) {
  if (!p) return {};
  const bit = (v) => (v === true || v === 1 ? true : v === false || v === 0 ? false : null);
  return {
    birincil: hexCoz(p.RenkBirincil),
    arkaplan: hexCoz(p.RenkArkaPlan),
    yazi: hexCoz(p.RenkYazi),
    kenar: hexCoz(p.RenkKenar),
    kose: koseCoz(p.Kose),
    font: fontCoz(p.YaziTipi),
    logo: bit(p.LogoGoster),
    otomatik: bit(p.OtomatikUyum),
    saydam: bit(p.SaydamArkaPlan),
  };
}

function temaKatmani(t) {
  if (!t || typeof t !== "object") return {};
  return {
    birincil: renkCoz(t.birincil),
    arkaplan: renkCoz(t.arkaplan),
    yazi: renkCoz(t.yazi),
    kose: koseCoz(t.kose),
    font: fontCoz(t.font),
  };
}

// §4.5: deger(alan) = profil ?? url ?? (otomatikAcik ? tema : null) ?? varsayılan(null)
export function birlestir(profil, url, tema) {
  const otomatikAcik = url.otomatik !== false && (gomuluDurum.profilVar ? profil.otomatik !== false : true);
  const s = {};
  ["birincil", "arkaplan", "yazi", "kenar", "kose", "font"].forEach((a) => {
    s[a] = ilkDolu(profil[a], url[a], otomatikAcik ? tema[a] : null);
  });
  s.logo = ilkDolu(profil.logo, url.logo, true);
  // GF-T5: saydam zemin yalnız otomatik uyum açıkken varsayılan (düz iframe koyu host'ta okunur kalsın)
  // GF-T15: …ve host script'i hepy:init gönderdiyse — script'siz düz iframe kendi açık zemininde (K-T5)
  // GF-T18 (K-T18): düz iframe'de (init yok) profil saydamlığı yok sayılır, yalnız URL saydam=1 geçerli —
  // profil değeri hiç null olmadığı için GF-T15 güvenliği profilli gömmede işlemiyordu. init gelince
  // yenidenUygula() bu satırı tekrar çalıştırır, profil saydamlığı script'li gömmede uygulanır.
  s.saydam = initAlindi ? ilkDolu(profil.saydam, url.saydam, otomatikAcik) : url.saydam === true;
  return s;
}

// ── Uygula: değişkenler document.documentElement.style'a (overlay'ler de görsün) ──
export function uygula(s) {
  const kok = document.documentElement;
  const st = kok.style;
  yazilanlar.forEach((k) => st.removeProperty(k));
  yazilanlar = [];
  const yaz = (k, v) => { st.setProperty(k, v); yazilanlar.push(k); };

  const zemin = s.arkaplan;
  const koyu = !!zemin && parlaklik(zemin) < 0.18;
  const yuzey = koyu ? karistir(zemin, BEYAZ, 0.06) : BEYAZ;

  // Sayfa arka planı: saydam → host görünür; değilse verilen renk; yoksa varsayılan gradient
  if (s.saydam) yaz("--gf-sayfa-arkaplan", "transparent");
  else if (zemin) yaz("--gf-sayfa-arkaplan", rgb(zemin));
  if (koyu) yaz("--gf-yuzey", uclu(yuzey));

  // Nötr ölçek (yazı): yazı rengi verildiyse ya da zemin koyuysa yeniden türetilir
  const yazi = s.yazi || (koyu ? [241, 245, 249] : null);
  const notrOzel = !!yazi;
  if (yazi) {
    const olcek = { 800: 0, 700: 0.12, 600: 0.25, 500: 0.4, 400: 0.55, 300: 0.72, 200: 0.84, 100: 0.91, 50: 0.95 };
    Object.keys(olcek).forEach((k) => yaz("--gf-n" + k, uclu(karistir(yazi, yuzey, olcek[k]))));
  }
  if (s.kenar) {
    yaz("--gf-n100", uclu(s.kenar));
    yaz("--gf-n200", uclu(s.kenar));
  }

  // Birincil ölçek: açık tonlar yüzeye, koyu tonlar siyaha doğru karıştırılır
  const birincil = s.birincil || (koyu ? TEAL500 : null);
  let bz = null;
  if (birincil) {
    const acik = { 50: 0.93, 100: 0.82, 200: 0.65, 300: 0.45, 400: 0.22 };
    const koyuT = { 600: 0.15, 700: 0.3, 800: 0.42, 900: 0.52 };
    Object.keys(acik).forEach((k) => yaz("--gf-b" + k, uclu(karistir(birincil, yuzey, acik[k]))));
    yaz("--gf-b500", uclu(birincil));
    Object.keys(koyuT).forEach((k) => yaz("--gf-b" + k, uclu(karistir(birincil, SIYAH, koyuT[k]))));
    bz = parlaklik(birincil) > 0.55 ? [17, 24, 39] : BEYAZ;
    yaz("--gf-bz", uclu(bz));
    // PrimeVue 5 token köprüsü (Aura: primary.* → --p-primary-*; highlight/focus ring bunlardan türer)
    yaz("--p-primary-color", rgb(birincil));
    yaz("--p-primary-hover-color", rgb(karistir(birincil, SIYAH, 0.15)));
    yaz("--p-primary-active-color", rgb(karistir(birincil, SIYAH, 0.3)));
    yaz("--p-primary-contrast-color", rgb(bz));
    Object.keys(acik).forEach((k) => yaz("--p-primary-" + k, rgb(karistir(birincil, yuzey, acik[k]))));
    yaz("--p-primary-500", rgb(birincil));
    Object.keys(koyuT).forEach((k) => yaz("--p-primary-" + k, rgb(karistir(birincil, SIYAH, koyuT[k]))));
  }

  if (notrOzel || koyu || s.kenar) {
    const n = (t) => (yazi ? karistir(yazi, yuzey, t) : null);
    if (koyu) {
      yaz("--p-form-field-background", rgb(yuzey));
      yaz("--p-content-background", rgb(yuzey));
      yaz("--p-overlay-select-background", rgb(karistir(zemin, BEYAZ, 0.1)));
      yaz("--p-overlay-popover-background", rgb(karistir(zemin, BEYAZ, 0.1)));
      yaz("--p-overlay-modal-background", rgb(karistir(zemin, BEYAZ, 0.1)));
      yaz("--p-inputgroup-addon-background", rgb(karistir(zemin, BEYAZ, 0.1)));
    }
    if (yazi) {
      yaz("--p-text-color", rgb(yazi));
      yaz("--p-text-muted-color", rgb(n(0.4)));
      yaz("--p-form-field-color", rgb(yazi));
      yaz("--p-form-field-placeholder-color", rgb(n(0.55)));
      yaz("--p-inputgroup-addon-color", rgb(n(0.4)));
      yaz("--p-list-option-color", rgb(yazi));
      yaz("--p-overlay-select-color", rgb(yazi));
      yaz("--p-overlay-modal-color", rgb(yazi));
    }
    const kenar = s.kenar || (yazi ? n(0.72) : null);
    if (kenar) {
      yaz("--p-form-field-border-color", rgb(kenar));
      yaz("--p-content-border-color", rgb(kenar));
      yaz("--p-inputgroup-addon-border-color", rgb(kenar));
      yaz("--p-overlay-select-border-color", rgb(kenar));
    }
  }

  // Köşe
  if (s.kose !== null && s.kose !== undefined) {
    yaz("--gf-kose", s.kose + "px");
    yaz("--gf-kose-alan", Math.min(s.kose, 12) + "px");
    yaz("--p-form-field-border-radius", Math.min(s.kose, 12) + "px");
    kok.classList.add("gf-kose-ozel");
  } else {
    kok.classList.remove("gf-kose-ozel");
  }

  // Yazı tipi (S3: dış istek yok; yalnız profil YaziTipiUrl)
  if (s.font) yaz("--gf-font", s.font + ", system-ui, sans-serif");
  const fUrl = profilHam && typeof profilHam.YaziTipiUrl === "string" ? profilHam.YaziTipiUrl.trim() : "";
  if (fUrl && HTTPS_RE.test(fUrl) && !fontLinki) {
    fontLinki = document.createElement("link");
    fontLinki.rel = "stylesheet";
    fontLinki.href = fUrl;
    document.head.appendChild(fontLinki);
  }

  gomuluDurum.logoGoster = s.logo !== false;
  kok.classList.toggle("gf-logo-gizli", s.logo === false);
}

function yenidenUygula() {
  uygula(birlestir(profilK, urlK, temaK));
  boyOlcPlanla();
}

// ── Mesajlaşma ──────────────────────────────────────────────────────────────
function hostOriginSenkron() {
  try {
    const ao = window.location.ancestorOrigins;
    if (ao && ao.length && ao[0] && ao[0] !== "null") return ao[0];
  } catch (e) { /* yoksay */ }
  try {
    if (document.referrer) {
      const o = new URL(document.referrer).origin;
      if (o && o !== "null") return o;
    }
  } catch (e) { /* yoksay */ }
  return null;
}

function kuyruguBosalt() {
  const k = kuyruk;
  kuyruk = [];
  k.forEach((m) => gonderHam(m));
}

function gonderHam(msg) {
  if (!hostOrigin) { kuyruk.push(msg); return; }
  try { window.parent.postMessage(msg, hostOrigin); } catch (e) { /* yoksay */ }
}

export function gonder(tip, alanlar) {
  if (!gomuluDurum.aktif || !cerceveIcinde()) return;
  gonderHam(Object.assign({ tip: "hepy:" + tip, v: PROTOKOL_V }, alanlar || {}));
}

function mesajAl(e) {
  if (e.source !== window.parent) return;
  const d = e.data;
  if (!d || typeof d !== "object" || typeof d.tip !== "string" || d.tip.indexOf("hepy:") !== 0 || d.v !== PROTOKOL_V) return;
  if (!hostOrigin) {
    if (d.tip !== "hepy:init") return;
    hostOrigin = e.origin; // sinyal yoktu: ilk init'in origin'i
    kuyruguBosalt();
  } else if (e.origin !== hostOrigin) {
    return; // farklı origin'den mesaj yok sayılır
  }
  if (d.tip === "hepy:init" || d.tip === "hepy:tema") {
    if (d.tip === "hepy:init" && !initAlindi) {
      initAlindi = true;
      const b = initBekleyenler;
      initBekleyenler = [];
      b.forEach((f) => f(hostOrigin));
    }
    temaK = temaKatmani(d.tema);
    yenidenUygula();
  }
}

function initBekle(ms) {
  if (initAlindi) return Promise.resolve(hostOrigin);
  return new Promise((coz) => {
    const z = setTimeout(() => coz(null), ms);
    initBekleyenler.push((o) => { clearTimeout(z); coz(o); });
  });
}

// ── Yükseklik (hepy:boy) ────────────────────────────────────────────────────
function boyOlc() {
  const app = document.getElementById("app") || document.body;
  let h = Math.ceil(app.getBoundingClientRect().height);
  // Açık overlay (Select/DatePicker) iframe'in altından taşmasın (R2)
  const sy = window.scrollY || 0;
  document.querySelectorAll(".p-select-overlay, .p-datepicker-panel, .p-autocomplete-overlay, .p-multiselect-overlay, .p-dialog")
    .forEach((el) => {
      const r = el.getBoundingClientRect();
      const alt = el.classList.contains("p-dialog") ? r.height + 32 : r.bottom + sy + 8;
      if (alt > h) h = Math.ceil(alt);
    });
  if (h > 0 && h !== sonBoy) {
    sonBoy = h;
    gonder("boy", { yukseklik: h });
  }
}

function boyOlcPlanla() {
  if (boyZamanlayici) clearTimeout(boyZamanlayici);
  boyZamanlayici = setTimeout(boyOlc, 60);
}

// ── Profil + izin ───────────────────────────────────────────────────────────
function alanListesi(v) {
  if (Array.isArray(v)) return v.map((x) => String(x || "").trim().toLowerCase()).filter(Boolean);
  if (typeof v === "string") return v.split(/[\s,;]+/).map((x) => x.trim().toLowerCase()).filter(Boolean);
  return [];
}

// Tam eşleşme ya da "*.ornek.com" (yalnız alt alanlar); şema/port/yol yok sayılır.
export function alanAdiEsle(kalip, host) {
  let k = String(kalip || "").toLowerCase().trim().replace(/^[a-z]+:\/\//, "");
  k = k.split("/")[0].split(":")[0];
  if (!k || !host) return false;
  if (k.indexOf("*.") === 0) {
    const kok = k.slice(2);
    return !!kok && host.length > kok.length && host.slice(-(kok.length + 1)) === "." + kok;
  }
  return host === k;
}

async function izinKontrol(p) {
  const liste = alanListesi(p && p.IzinliAlanAdlari);
  if (!liste.length) return true; // boş liste = her yerde
  if (!cerceveIcinde()) return true; // tam sayfa açılış: profil erişim kapısı değil (plan §4.7)
  const origin = hostOrigin || (await initBekle(INIT_BEKLEME_MS));
  if (!origin) return false; // S2: sinyal yok → fail-closed
  if (origin === window.location.origin) return true; // panelin kendi önizlemesi
  let host;
  try { host = new URL(origin).hostname.toLowerCase(); } catch (e) { return false; }
  return liste.some((k) => alanAdiEsle(k, host));
}

// Profil ucu (GF3 BE) yoksa 404/hata → profil yok sayılır, form açılır (geriye uyum).
export async function profilYukle(servis, kimlik) {
  if (!kimlik || !kimlik.Kod || !KOD_RE.test(kimlik.Kod) || typeof servis !== "function") return null;
  const zamanAsimi = new Promise((coz) => setTimeout(() => coz(null), PROFIL_BEKLEME_MS));
  const istek = servis("POST", "GetGomuluFormProfilPublic", {
    SubeGuid: kimlik.SubeGuid || null,
    SirketGuid: kimlik.SirketGuid || null,
    Kod: kimlik.Kod,
  })
    .then((res) => (res && res.status === 200 && res.data && typeof res.data === "object" ? res.data : null))
    .catch(() => null);
  return Promise.race([istek, zamanAsimi]);
}

function profilUygula(p) {
  profilHam = p || null;
  gomuluDurum.profilVar = !!p;
  profilK = profilKatmani(p);
  gomuluDurum.butonMetni = p && typeof p.ButonMetni === "string" ? p.ButonMetni.trim().slice(0, 60) : "";
  gomuluDurum.sonrasiMesaj = p && typeof p.SonrasiMesaj === "string" ? p.SonrasiMesaj.trim().slice(0, 500) : "";
  const su = p && typeof p.SonrasiUrl === "string" ? p.SonrasiUrl.trim() : "";
  gomuluDurum.sonrasiUrl = HTTP_RE.test(su) ? su : "";
}

// ── Giriş noktası: AuthLayout.mounted ───────────────────────────────────────
export async function baslat(servis) {
  if (baslatildi) return;
  const aktif = gomuluMu();
  baslatildi = true;
  if (!aktif) { gomuluDurum.hazir = true; return; }

  let q;
  try { q = new URLSearchParams(window.location.search); } catch (e) { q = new URLSearchParams(""); }
  gomuluDurum.aktif = true;
  document.documentElement.classList.add("gf-gomulu");
  urlK = urlKatmani(q);
  yenidenUygula(); // URL katmanı ilk boyamadan önce

  if (cerceveIcinde()) {
    hostOrigin = hostOriginSenkron();
    window.addEventListener("message", mesajAl);
    try {
      const app = document.getElementById("app") || document.body;
      if (window.ResizeObserver) new ResizeObserver(boyOlcPlanla).observe(app);
      if (window.MutationObserver) new MutationObserver(boyOlcPlanla).observe(document.body, { childList: true });
    } catch (e) { /* yoksay */ }
    window.addEventListener("load", boyOlcPlanla);
    watch(kirliVarMi, (kirli) => gonder("kirli", { kirli: !!kirli }));
  }

  const kod = (q.get("profil") || "").trim().toLowerCase();
  const p = kod
    ? await profilYukle(servis, { Kod: kod, SubeGuid: q.get("SubeGuid"), SirketGuid: q.get("SirketGuid") })
    : null;
  profilUygula(p);
  yenidenUygula();

  const izinli = await izinKontrol(p);
  if (!izinli) {
    gomuluDurum.kilitli = true;
    gonder("hata", { kod: "kilitli" });
  }
  gomuluDurum.hazir = true;
  gonder("hazir", { form: FORM_YOLLARI[window.location.pathname.replace(/\/+$/, "").toLowerCase()] || null });
  boyOlcPlanla();
}

// 200 sonrası formlar çağırır. PII yok. Döner: profil sonrası mesajı (yoksa "").
export function gonderildi(form) {
  if (!gomuluDurum.aktif) return "";
  gonder("gonderildi", { form: form, zaman: new Date().toISOString() });
  const url = gomuluDurum.sonrasiUrl;
  if (url) {
    gonder("yonlendir", { url: url });
    gomuluDurum.devamUrl = url;
    if (!initAlindi) {
      // Script'siz iframe: üst pencereyi yönlendirmeyi dene (tarayıcı engelleyebilir → "Devam et")
      try { window.top.location.href = url; } catch (e) { /* engellendi */ }
    }
  }
  boyOlcPlanla();
  return gomuluDurum.sonrasiMesaj;
}

export default {
  gomuluDurum, gomuluMu, urlKatmani, birlestir, uygula, baslat, profilYukle, gonder, gonderildi, alanAdiEsle,
};
